function validateMinLength(minLength: number, value?: string | null): boolean {
  return value !== undefined && value !== null && value.length >= minLength;
}

export default validateMinLength;
